(function () {
    'use strict';

    angular.module('Directives').directive('bbaProfileManagerAddress', bbaProfileManagerAddress);

    bbaProfileManagerAddress.$inject = [
        'ClientsListsRepositoryFactory',
        'ClientService',
        '$timeout',
        'aborter',
        'Location',
        '$q'
    ];

    function bbaProfileManagerAddress(
        ClientsListsRepositoryFactory,
        ClientService,
        $timeout,
        aborter,
        Location,
        $q
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/bba-profile-manager/bba-profile-manager-address.html',
            scope: {
                step: '=',
                isViewMode: '=?',
                init: '='
            },
            controller: bbaProfileManagerAddressController,
            controllerAs: 'vm',
            bindToController: true
        };

        function bbaProfileManagerAddressController($scope) {
            let vm = this;
            vm.officeTypes = {
                custom: 'Custom',
                warehouse: 'Warehouse',
                crossdock: 'Cross Dock',
                thirdpartylogistics: 'Third Party Logistics'
            };

            vm.searchForCompanies = searchForCompanies;
            vm.onCompanySelected = onCompanySelected;
            vm.searchForLocations = searchForLocations;
            vm.searchForStates = searchForStates;

            vm.populateAddress = populateAddress;

            init();

            $scope.$watch(() => this.init, value => {
                if (value) init();
            });

            vm.hasInitialized = false;

            $scope.$watch(() => this.warehouse.firstName, useCustomOffice);
            $scope.$watch(() => this.warehouse.lastName, useCustomOffice);
            $scope.$watch(() => this.warehouse.phone1, useCustomOffice);
            $scope.$watch(() => this.warehouse.phone2, useCustomOffice);
            $scope.$watch(() => this.warehouse.address1, useCustomOffice);
            $scope.$watch(() => this.warehouse.address2, useCustomOffice);
            $scope.$watch(() => this.warehouse.location, useCustomOffice);
            $scope.$watch(() => this.warehouse.code, useCustomOffice);

            function useCustomOffice() {
                if (vm.hasInitialized && !vm.officeChanged) {
                    vm.step.details.office = vm.client.lists.locations.content && vm.client.lists.locations.content[0] || {
                        name: 'Custom',
                        custom: true
                    };
                    populateAddress(vm.step.details.office, false);
                } else if (vm.officeChanged) {
                    $timeout(() => {
                        vm.officeChanged = false;
                    });
                }
            }

            function init() {
                vm.warehouse = vm.step.details[vm.step.warehouseName];
                vm.companies = [];
                vm.client = ClientsListsRepositoryFactory;
                vm.useWarehouseFromCompany = vm.step.details.office;
                vm.officeType = vm.officeTypes[vm.warehouse.officeType || 'custom'];
                $timeout(() => { vm.hasInitialized = true; });
            }

            function searchForCompanies(select) {
                vm.companies = [];
                if (!select.open) {
                    return false;
                }
                vm.searching = true;
                ClientService.Company.getAll(
                    function (data) {
                        vm.companies = data.content;
                        vm.searching = false;
                    }, function () {
                        vm.searching = false;
                    }, {
                    size: 20, active: true, name: select.search
                });
            }

            function onCompanySelected(company) {
                if (vm.step.details.office && (!vm.step.details.office.company || vm.step.details.office.company.id !== company.id)) {
                    vm.step.details.office = {
                        name: 'Custom',
                        custom: true
                    };
                    vm.officeType = 'Custom';
                }
            }

            function searchForLocations(select, companyId) {
                if (select.open) {
                    vm.client.lists.locations.content = [];
                    vm.searching = true;
                    vm.client.lists.locations.update({
                        company: companyId, name: select.search
                    }).then(() => {
                        vm.client.lists.locations.content.unshift({
                            name: 'Custom',
                            custom: true
                        });
                        vm.searching = false;
                    }).catch(() => {
                        vm.searching = false;
                    });
                } else {
                    select.search = select.selected && select.selected.name || '';
                }
            }

            function populateAddress(selected, officeChanged) {
                const office = angular.copy(selected);
                if (office.custom) {
                    angular.extend(vm.warehouse, {
                        name: 'Custom',
                        officeType: 'custom'
                    });
                } else {
                    office.address1 = office.addressLine1 || '';
                    office.address2 = office.addressLine2 || '';
                    angular.extend(vm.warehouse, {
                        name: office.name,
                        firstName: office.firstName,
                        lastName: office.lastName,
                        phone1: office.phone1,
                        phone2: office.phone2,
                        email: office.email,
                        address1: office.address1,
                        address2: office.address2,
                        location: office.location,
                        officeType: (office.officeType || 'custom').toLowerCase(),
                        code: office.code
                    });
                }
                vm.officeType = vm.officeTypes[vm.warehouse.officeType || 'custom'];
                vm.officeChanged = officeChanged;
            }

            function searchForStates(searchTerm) {
                vm.states = [];
                aborter(() => {
                    vm.isSearching = true;
                    const countryCode = angular.getObjVal(vm.warehouse, 'location.country.code');
                    const country = vm.warehouse.countries.find(c => c.code === countryCode);

                    Location.State(angular.getObjVal(country, 'id'), (data) => {
                        console.log(data);
                        vm.isSearching = false;
                        const statesData = data.map(loc => loc.name);
                        vm.states = statesData.filter((state, index) => statesData.indexOf(state) === index);
                    }, error => { }, {}, {name: searchTerm});
                }, 500);
            }
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/component/bba-profile-manager/bbaProfileManagerAddress.js